// extracted by mini-css-extract-plugin
export default {"HeaderElement":"MainHead_HeaderElement__TL6ZY","HeaderDisc":"MainHead_HeaderDisc__g9JJn","raahyabBtn":"MainHead_raahyabBtn__gW+0a"};